import { BehaviorSubject } from 'rxjs';
import { pairwise, map } from 'rxjs/operators';
import _ from 'lodash';

class StateSubject {
  constructor(initState) {
    this.state = initState;
    this._stateSubject$ = new BehaviorSubject(initState);
  }

  get stateSubject$() {
    return this._stateSubject$;
  }

  setPartialState(partialState) {
    const newState = { ...this.state, ...partialState };
    if (!_.isEqual(this.state, newState)) {
      this.stateSubject$.next(newState);
      this.state = newState;
    }
  }

  setState(state) {
    if (!_.isEqual(this.state, state)) {
      this.stateSubject$.next({ ...state });
      this.state = { ...state };
    }
  }
}

export const createStateDifferenceObservable = observable => {
  return observable.pipe(pairwise()).pipe(
    map(([oldState, newState]) => {
      const diffObject = {};
      Object.keys(newState)
        .filter(x => !Object.keys(oldState).includes(x))
        .forEach(key => {
          diffObject[key] = newState[key];
        });
      Object.keys(oldState)
        .filter(x => !Object.keys(newState).includes(x))
        .forEach(key => {
          diffObject[key] = null;
        });
      Object.keys(newState)
        .filter(x => Object.keys(oldState).includes(x))
        .forEach(key => {
          if (!_.isEqual(newState[key], oldState[key])) {
            diffObject[key] = newState[key];
          }
        });
      return diffObject;
    }),
  );
};

export default StateSubject;



// WEBPACK FOOTER //
// ./src/js/search/StateSubject.js